module.exports = __webpack_public_path__ + "static/media/astronaut-sitting.613c6d7a.svg";